import dayjs from "dayjs";
import type { FC } from "react";
import { EmailCard } from "../../../../components/EmailCard/EmailCard";
import type { EmailMatch } from "../../../../hooks/useMatchingRestApi";
import { ReactComponent as Check } from "./check.svg";
import { ReactComponent as Warning } from "./warning.svg";
export interface MatchingResultItemProps {
  result: EmailMatch;
}

export const MatchingResultItem: FC<MatchingResultItemProps> = ({ result }) => (
  <EmailCard
    isMatter={true}
    emailId={result.emailId}
    title={result.subject}
    date={dayjs(result.date).toString()}
    period={result.matterColumn?.period || null}
    content={result.content}
    reward={
      result.matterColumn?.rewardInt
        ? result.matterColumn?.rewardInt
        : result.matterColumn?.reward
          ? result.matterColumn?.reward
          : null
    }
    isRemoteEnabled={result.matterColumn?.isRemoteEnabled || false}
    station={result.matterColumn?.station || null}
    numberOfInterviews={result.matterColumn?.numberOfInterviews || null}
    otherCountriesEnabled={result.matterColumn?.otherCountriesEnabled || false}
    workingTimeWidth={result.matterColumn?.workingTimeWidth || null}
    endOrPrimeContractorDirect={
      result.matterColumn?.endOrPrimeContractorDirect || null
    }
    technology={result.matterColumn?.technology || null}
    industryCategory={result.matterColumn?.industryCategory || null}
    remoteFrequency={result.matterColumn?.remoteFrequency || null}
    matchScore={result.matchScore >= 0 ? result.matchScore : null}
    description={
      <div>
        <div className="flex items-start">
          <Check className="w-4 h-4 mr-2 mt-1" />
          <div className="flex-1">
            <span className="text-sm font-medium text-gray-700">
              マッチング理由
            </span>
            <p className="text-sm text-gray-600 mt-1">{result.reason}</p>
          </div>
        </div>
        {result.concerns && (
          <div className="flex items-start mt-3">
            <Warning className="w-4 h-4 mr-2 mt-1" />
            <div className="flex-1">
              <span className="text-sm font-medium text-gray-700">懸念点</span>
              <p className="text-sm text-gray-600 mt-1">{result.concerns}</p>
            </div>
          </div>
        )}
      </div>
    }
    scrollCardRef={null}
    scrollCardId={null}
  />
);

export default MatchingResultItem;
